import { FormControl, Grid, MenuItem, Select, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Account } from '../../types';
import DollarsAndCentsText from '../DollarAndCentsText';

const useStyles = makeStyles((theme) => ({
  selectAccountContainer: {
    width: '100%',
    padding: theme.spacing(0, 2.5),
  },
  accountName: {
    fontWeight: 700,
  },
  selectAccountForm: {
    width: '100%',
  },
  selectMenu: {
    width: '23%',
  },
}));

type AccountSelectProps = {
  accounts: Account[];
  selectedAccount?: Account | undefined;
  onChange: (account: Account) => void;
};

const AccountSelect = (props: AccountSelectProps) => {
  const { accounts, selectedAccount, onChange } = props;
  const classes = useStyles();

  const handleAccountChange = (event: any) => {
    const gcAccountId = event.target.value;

    const selectedBuyerAccount = accounts.find((x) => x.gcAccountId == gcAccountId);
    if (selectedBuyerAccount) {
      onChange(selectedBuyerAccount);
    }
  };

  return (
    <Grid container className={classes.selectAccountContainer}>
      <Grid item xs={12}>
        <Typography variant='subtitle2' component='label'>
          Please select from these business accounts linked to your mobile number below:
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormControl className={classes.selectAccountForm} variant='outlined'>
          <Select
            name='accounts'
            id='accounts'
            data-testid='uia-accounts'
            onChange={handleAccountChange}
            value={selectedAccount && selectedAccount.gcAccountId}
            placeholder='SELECT A ACCOUNT'
            MenuProps={{ PaperProps: { className: classes.selectMenu } }}
          >
            {accounts &&
              accounts.map((account: Account) => (
                <MenuItem key={account.gcAccountId} data-testid='uia-accountItem' value={account.gcAccountId} disabled={!account.hasBalanceToProcess}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant='subtitle2' className={classes.accountName} component='label'>
                        {account.name}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant='body2' component='label'>
                        Available balance: <DollarsAndCentsText amount={account.availableBalance} />
                      </Typography>
                    </Grid>
                  </Grid>
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default AccountSelect;
